






















import { Vue, Component, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { CourseStatusCountsDTO } from '@/store/modules/jtms/course/course.types';
import { ApiState } from '@/store/types/general.types';
import CourseStatusCountItem from './components/CourseStatusCountItem.vue';

@Component({
  components: { CourseStatusCountItem }
})
export default class CourseStatusCount extends Vue {
  @Action('course/getCoursesCountForEachStatus')
  getCoursesCountForEachStatus!: () => Promise<CourseStatusCountsDTO>;

  @State((state: RootState) => state.course.courseCountForEachStatus)
  public courseCountForEachStatus!: CourseStatusCountsDTO;

  @State(
    ({ course }: RootState) =>
      course.apiState.getCourseCountForEachStatus.success
  )
  public getCourseCountForEachStatusSuccess!: ApiState;

  // Mapping the return objects for dynamic content rendering based on course status
  public coursePublicationStatusMap = new Map<
    string,
    { routeKey: string; displayName: string; count?: number }
  >([
    ['published', { routeKey: 'published', displayName: 'Published' }],
    ['draft', { routeKey: 'draft', displayName: 'Draft' }],
    ['inProgress', { routeKey: 'in-progress', displayName: 'In Progress' }],
    ['cancelled', { routeKey: 'cancelled', displayName: 'Cancelled' }],
    ['completed', { routeKey: 'completed', displayName: 'Completed' }]
  ]);

  public readonly tooltipDescription: string[] = [
    'Courses that are published',
    'Courses that are saved in draft',
    'Courses that are currently \n in-progress',
    'Courses that have been cancelled',
    'Courses that have been completed'
  ];

  public mounted() {
    this.getCoursesCountForEachStatus();
  }

  getCourseRoute(
    status: string
  ): { name: string; params: { courseStatus: string; count: number } } {
    const {
      routeKey: courseStatus,
      count: courseCount
    } = this.coursePublicationStatusMap.get(status)!;
    return {
      name: 'view-courses-by-status',
      params: {
        // If status is not found in statusMapping, default to 'published'
        courseStatus: courseStatus ? courseStatus : 'published',
        count: courseCount ? courseCount : 0
      }
    };
  }

  @Watch('getCourseCountForEachStatusSuccess')
  // Set values returned from API into `count` mapped object
  onGetCoursesCountForEachStatusSuccess() {
    /**
     * Check if courseCountForEachStatus is defined and not empty to prevent
     * mapping before API call success.
     */
    if (
      this.courseCountForEachStatus &&
      Object.keys(this.courseCountForEachStatus).length > 0
    ) {
      Object.keys(this.courseCountForEachStatus).forEach((key) => {
        const currentCourseStatus = this.coursePublicationStatusMap.get(key)!;
        this.coursePublicationStatusMap.set(key, {
          ...currentCourseStatus,
          count: +this.courseCountForEachStatus[
            key as keyof CourseStatusCountsDTO
          ]
        });
      });
    }
  }
}
